import Link from "next/link";
import { IconArrowUpRight, IconBrandWhatsapp, IconMail } from "@tabler/icons-react";
import { contact, cta, processSteps } from "@/constants/site";
import SectionHeading from "./SectionHeading";

export function ProcessSection() {
  return (
    <section className="rounded-[20px] border border-white/[0.06] bg-black p-5 sm:p-6 md:p-10">
      <SectionHeading
        eyebrow="How I work"
        title="From manual process to automated system"
        subtitle="A clear, milestone-based process, so you always know what's being built and when."
      />

      <ol className="mt-8 grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
        {processSteps.map((p, i) => (
          <li
            key={p.step}
            className="relative rounded-[16px] border border-white/[0.06] bg-[#0E1018] p-5 sm:p-6"
          >
            <span className="text-[40px] font-bold leading-none text-transparent [-webkit-text-stroke:1px_#48AEEF]">
              {p.step}
            </span>
            <h3 className="mt-4 text-[19px] font-bold">{p.title}</h3>
            <p className="mt-2 text-[15px] leading-relaxed text-[#868E96]">{p.description}</p>
            {i < processSteps.length - 1 && (
              <span
                aria-hidden
                className="absolute right-[-13px] top-1/2 z-10 hidden h-px w-[22px] bg-gradient-to-r from-[#48AEEF]/60 to-transparent xl:block"
              />
            )}
          </li>
        ))}
      </ol>
    </section>
  );
}

export function CtaSection() {
  return (
    <section className="relative overflow-hidden rounded-[20px] border border-white/[0.06] bg-black p-6 text-center sm:p-8 md:p-14">
      <div
        aria-hidden
        className="pointer-events-none absolute left-1/2 top-0 h-64 w-[600px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#48AEEF]/20 blur-3xl"
      />
      <div className="relative mx-auto max-w-[720px]">
        <h2 className="text-[28px] font-bold leading-tight tracking-tight md:text-[40px]">{cta.title}</h2>
        <p className="mt-4 text-[16px] leading-relaxed text-[#868E96] md:text-[18px]">{cta.subtitle}</p>

        <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
          <Link
            href={contact.whatsapp}
            target="_blank"
            className="group inline-flex h-12 shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-[12px] bg-white px-6 text-[16px] font-bold text-black transition-colors hover:bg-white/90"
          >
            <IconBrandWhatsapp size={20} />
            Chat on WhatsApp
            <IconArrowUpRight size={17} className="transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </Link>
          <Link
            href={`mailto:${contact.email}`}
            className="inline-flex min-h-12 min-w-0 items-center justify-center gap-2 rounded-[12px] py-2 sm:shrink-0 border border-white/10 bg-[#0E1018] px-3 text-[13px] min-[360px]:px-4 min-[360px]:text-[14px] font-bold text-white transition-colors hover:bg-[#161a26] sm:px-6 sm:text-[16px]"
          >
            <IconMail size={20} className="shrink-0" />
            <span className="text-left [overflow-wrap:anywhere]">{contact.email}</span>
          </Link>
        </div>
      </div>
    </section>
  );
}
